import {findReportTypeSection} from 'ducks/reportSections';
import get from 'lodash/get';

export const makeSummarySection = (reportSections) => {
  const summarySection = findReportTypeSection(reportSections, 'SUMMARY');
  return {
    appraisalPriceRange: get(summarySection, 'sectionData.appraisalPriceRange'),
    description: get(summarySection, 'sectionData.description'),
  };
};